import React from 'react'
import PropTypes from 'prop-types'

class ContentArea extends React.Component {
  constructor(props) {
    super(props)
  }

  render = () => (
    <div
      className={
        this.props.centered
          ? 'c-content-area c-content-area--centered o-width-limiter'
          : 'c-content-area o-width-limiter'
      }
    >
      <div
        className={
          this.props.wide
            ? 'c-content-area__inner c-content-area__inner--wide'
            : 'c-content-area__inner'
        }
      >
        {this.props.children}
      </div>
    </div>
  )
}

ContentArea.propTypes = {
  centered: PropTypes.bool,
  children: PropTypes.node,
  wide: PropTypes.bool,
}

export default ContentArea
